/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable  */
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Loading from '../../components/Loading';
import { Container } from '../../styles/layout/Container';
import {
   PageHeader,
   PageHeaderText,
   PageHeaderActions,
   PageTitle,
} from '../../styles/layout/PageHeader';
import {
   Section,
   SectionBody,
   SectionHeader,
   SectionTitle,
} from '../../styles/layout/Section';
import { FormGrid } from '../../styles/layout/FormGrid';
import { Field } from '../../styles/forms/Field';
import { TableWrapper } from '../../styles/table/TableWrapper';
import { Table } from '../../styles/table/Table';

// ─────────────────────────────────────────────────────────────────────────────
// Estilos locais
// ─────────────────────────────────────────────────────────────────────────────

const ServiceOrderStatusBadge = styled.span`
   display: inline-flex;
   align-items: center;
   padding: 6px 14px;
   border-radius: 999px;
   font-size: 13px;
   font-weight: 700;
   border: 1px solid
      ${({ $statusColor }) => $statusColor?.border ?? 'rgba(0,0,0,0.15)'};
   background: ${({ $statusColor }) => $statusColor?.bg ?? 'rgba(0,0,0,0.06)'};
   color: ${({ $statusColor }) => $statusColor?.text ?? '#444'};
`;

const OsHeaderMeta = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   flex-wrap: wrap;
   margin-top: 8px;
`;

const OsMetaChip = styled.span`
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#888'};
   display: flex;
   align-items: center;
   gap: 4px;
`;

const OsMetaSeparator = styled.span`
   color: ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.2)'};
   font-size: 14px;
`;

/* ── Layout principal: conteúdo + timeline lateral ── */
const OsLayout = styled.div`
   display: grid;
   gap: 16px;
   grid-template-columns: 1fr;

   @media (min-width: 1024px) {
      grid-template-columns: 1fr 300px;
      align-items: start;
   }
`;

const OsMainContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 0;
   min-width: 0;
`;

const OsSidebar = styled.div`
   display: flex;
   flex-direction: column;
   gap: 16px;
   position: sticky;
   top: 24px;
`;

/* ── Seção colapsável ── */
const CollapsibleSectionHeader = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   cursor: pointer;
   user-select: none;
   padding: 2px 0 6px;
`;

const CollapsibleToggleIcon = styled.span`
   font-size: 11px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#aaa'};
   transition: transform 0.2s;
   transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
   display: inline-block;
`;

/* ── Timeline horizontal de cards ── */

// Wrapper com scroll horizontal em telas pequenas
const TimelineHorizontalWrapper = styled.div`
   width: 100%;
   overflow-x: auto;
   -webkit-overflow-scrolling: touch;
   padding-bottom: 4px;
`;

// Trilho que contém os cards e os conectores entre eles
const TimelineHorizontalTrack = styled.div`
   display: flex;
   align-items: flex-start;
   min-width: max-content;
   gap: 0;
   padding: 4px 0 8px;
`;

// Conector entre dois cards — linha + seta
const TimelineHorizontalConnector = styled.div`
   display: flex;
   align-items: center;
   flex-shrink: 0;
   width: 32px;
   margin-top: 18px; /* alinha com o centro do dot do card */
   position: relative;

   &::before {
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      background: ${({ $done, $branch, theme }) =>
         $branch
            ? 'rgba(186,117,23,0.4)'
            : $done
              ? theme?.colors?.success ?? '#2e7d32'
              : theme?.colors?.border ?? 'rgba(0,0,0,0.15)'};
   }

   &::after {
      content: '›';
      position: absolute;
      right: -4px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      line-height: 1;
      color: ${({ $done, $branch, theme }) =>
         $branch
            ? 'rgba(186,117,23,0.6)'
            : $done
              ? theme?.colors?.success ?? '#2e7d32'
              : theme?.colors?.border ?? 'rgba(0,0,0,0.2)'};
   }
`;

// Card individual de etapa
const TimelineStepCard = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 120px;
   flex-shrink: 0;
   cursor: default;
   opacity: ${({ $future }) => ($future ? 0.45 : 1)};
`;

const TimelineStepDot = styled.div`
   width: 14px;
   height: 14px;
   border-radius: 50%;
   flex-shrink: 0;
   margin-bottom: 8px;
   background: ${({ $current, $done, $detour, theme }) =>
      $current
         ? theme?.colors?.appBackground ?? '#1a237e'
         : $detour
           ? '#854f0b'
           : $done
             ? theme?.colors?.success ?? '#2e7d32'
             : theme?.colors?.border ?? 'rgba(0,0,0,0.2)'};
   border: 2px solid
      ${({ $current, $done, $detour, theme }) =>
         $current
            ? theme?.colors?.appBackground ?? '#1a237e'
            : $detour
              ? '#854f0b'
              : $done
                ? theme?.colors?.success ?? '#2e7d32'
                : theme?.colors?.border ?? 'rgba(0,0,0,0.2)'};
   box-shadow: ${({ $current }) =>
      $current ? '0 0 0 3px rgba(24,95,165,0.18)' : 'none'};
`;

const TimelineStepLabel = styled.div`
   font-size: 11px;
   font-weight: ${({ $current }) => ($current ? '700' : '500')};
   text-align: center;
   line-height: 1.3;
   color: ${({ $current, $done, $detour, theme }) =>
      $current
         ? theme?.colors?.appBackground ?? '#1a237e'
         : $detour
           ? '#854f0b'
           : $done
             ? theme?.colors?.textSecondary ?? '#333'
             : theme?.colors?.textMuted ?? '#aaa'};
   margin-bottom: 4px;
`;

const TimelineStepTimestamp = styled.div`
   font-size: 10px;
   text-align: center;
   line-height: 1.3;
   color: ${({ $done, $detour }) =>
      $detour ? '#aa7030' : $done ? '#555' : '#bbb'};
   font-style: ${({ $pending }) => ($pending ? 'italic' : 'normal')};
`;

// Grupo de desvios (sempre visível — cinza se não percorrido, laranja se ativado)
const TimelineDetourRow = styled.div`
   display: flex;
   align-items: flex-start;
   gap: 8px;
   margin-top: 6px;
   padding-top: 6px;
   border-top: 1px dashed
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.1)'};
`;

const TimelineDetourRowLabel = styled.div`
   font-size: 10px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#bbb'};
   white-space: nowrap;
   margin-top: 2px;
   flex-shrink: 0;
`;

const TimelineDetourGroup = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   flex-shrink: 0;
`;

const TimelineDetourConnectorVertical = styled.div`
   width: 2px;
   height: 10px;
   background: ${({ $active }) =>
      $active ? 'rgba(186,117,23,0.5)' : 'rgba(0,0,0,0.1)'};
`;

const TimelineDetourCard = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 110px;
   padding: 6px 8px;
   border-radius: 8px;
   border: 1px solid
      ${({ $active }) =>
         $active ? 'rgba(186,117,23,0.35)' : 'rgba(0,0,0,0.1)'};
   background: ${({ $active }) =>
      $active ? 'rgba(186,117,23,0.07)' : 'rgba(0,0,0,0.025)'};
   transition:
      border-color 0.2s,
      background 0.2s;
`;

const TimelineDetourDot = styled.div`
   width: 8px;
   height: 8px;
   border-radius: 50%;
   margin-bottom: 5px;
   background: ${({ $active, $current }) =>
      $current
         ? '#854f0b'
         : $active
           ? 'rgba(186,117,23,0.5)'
           : 'rgba(0,0,0,0.12)'};
   border: 2px solid
      ${({ $active, $current }) =>
         $current
            ? '#854f0b'
            : $active
              ? 'rgba(186,117,23,0.4)'
              : 'rgba(0,0,0,0.15)'};
   box-shadow: ${({ $current }) =>
      $current ? '0 0 0 3px rgba(186,117,23,0.2)' : 'none'};
`;

const TimelineDetourLabel = styled.div`
   font-size: 10px;
   font-weight: ${({ $active }) => ($active ? '700' : '400')};
   color: ${({ $active, $current }) =>
      $current ? '#854f0b' : $active ? '#aa7030' : 'rgba(0,0,0,0.25)'};
   text-align: center;
   line-height: 1.3;
   margin-bottom: 3px;
`;

const TimelineDetourTimestamp = styled.div`
   font-size: 9px;
   color: ${({ $active }) => ($active ? '#aa7030' : 'rgba(0,0,0,0.2)')};
   text-align: center;
   line-height: 1.3;
   font-style: italic;
`;

/* ── Bloco de diagnóstico destacado ── */
const DiagnosisBlock = styled.div`
   background: ${({ theme }) =>
      theme?.colors?.primarySoft ?? 'rgba(24,95,165,0.05)'};
   border-left: 3px solid
      ${({ theme }) => theme?.colors?.appBackground ?? '#1a237e'};
   border-radius: 0 8px 8px 0;
   padding: 12px 14px;
   font-size: 13px;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   line-height: 1.6;
   min-height: 60px;
   white-space: pre-wrap;
`;

const DefectReportBlock = styled.div`
   background: rgba(183, 28, 28, 0.04);
   border-left: 3px solid rgba(183, 28, 28, 0.4);
   border-radius: 0 8px 8px 0;
   padding: 12px 14px;
   font-size: 13px;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   line-height: 1.6;
   min-height: 60px;
   white-space: pre-wrap;
`;

const ObjectObsBlock = styled.div`
   background: ${({ theme }) => theme?.colors?.surface ?? '#f9f9f7'};
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   border-radius: 8px;
   padding: 10px 12px;
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textSecondary ?? '#555'};
   line-height: 1.5;
   font-style: italic;
`;

/* ── Peças/serviços ── */
const PartsTableActionBar = styled.div`
   display: flex;
   gap: 8px;
   align-items: flex-end;
   flex-wrap: wrap;
   margin-bottom: 12px;
`;

const PartsTotalRow = styled.div`
   display: flex;
   justify-content: flex-end;
   align-items: center;
   gap: 16px;
   padding: 10px 12px 0;
   font-size: 13px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#888'};
   border-top: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   margin-top: 8px;
`;

const PartsTotalValue = styled.span`
   font-weight: 700;
   font-size: 15px;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;

/* ── Botão de avanço de status ── */
const StatusAdvanceButton = styled.button`
   width: 100%;
   padding: 10px;
   border-radius: 8px;
   font-size: 13px;
   font-weight: 700;
   border: none;
   background: ${({ theme }) => theme?.colors?.appBackground ?? '#1a237e'};
   color: #fff;
   cursor: pointer;
   transition: opacity 0.15s;

   &:hover {
      opacity: 0.88;
   }

   &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
   }
`;

const SlaCountdownBadge = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 12px;
   border-radius: 8px;
   font-size: 12px;
   background: ${({ $overdue }) =>
      $overdue ? 'rgba(183,28,28,0.08)' : 'rgba(46,125,50,0.08)'};
   border: 1px solid
      ${({ $overdue }) =>
         $overdue ? 'rgba(183,28,28,0.2)' : 'rgba(46,125,50,0.2)'};
   color: ${({ $overdue }) => ($overdue ? '#b71c1c' : '#2e7d32')};
   font-weight: 600;
`;

const PhotoGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
   gap: 8px;
   margin-top: 8px;
`;

const PhotoThumb = styled.div`
   width: 100%;
   aspect-ratio: 1;
   border-radius: 8px;
   background: ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.1)'};
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 22px;
   cursor: pointer;
   overflow: hidden;

   img {
      width: 100%;
      height: 100%;
      object-fit: cover;
   }

   &:hover {
      opacity: 0.8;
   }
`;

const PhotoUploadButton = styled.label`
   width: 100%;
   aspect-ratio: 1;
   border-radius: 8px;
   border: 2px dashed
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.15)'};
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   font-size: 10px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#aaa'};
   cursor: pointer;
   gap: 4px;

   &:hover {
      border-color: ${({ theme }) => theme?.colors?.appBackground ?? '#1a237e'};
      color: ${({ theme }) => theme?.colors?.appBackground ?? '#1a237e'};
   }

   input {
      display: none;
   }
`;

// ─────────────────────────────────────────────────────────────────────────────
// Constantes
// ─────────────────────────────────────────────────────────────────────────────

const SERVICE_ORDER_STATUS_COLORS = {
   AGUARDANDO_RECEBIMENTO: {
      bg: 'rgba(0,0,0,0.06)',
      border: 'rgba(0,0,0,0.15)',
      text: '#444',
   },
   EM_TRIAGEM: {
      bg: 'rgba(83,74,183,0.10)',
      border: 'rgba(83,74,183,0.30)',
      text: '#3c3489',
   },
   AGUARDANDO_PECAS: {
      bg: 'rgba(186,117,23,0.12)',
      border: 'rgba(186,117,23,0.30)',
      text: '#854f0b',
   },
   EM_REPARO: {
      bg: 'rgba(24,95,165,0.10)',
      border: 'rgba(24,95,165,0.30)',
      text: '#0c447c',
   },
   AGUARDANDO_APROVACAO: {
      bg: 'rgba(216,90,48,0.10)',
      border: 'rgba(216,90,48,0.30)',
      text: '#712b13',
   },
   REPARO_CONCLUIDO: {
      bg: 'rgba(15,110,86,0.10)',
      border: 'rgba(15,110,86,0.30)',
      text: '#085041',
   },
   PRONTO_PARA_ENTREGA: {
      bg: 'rgba(59,109,17,0.10)',
      border: 'rgba(59,109,17,0.30)',
      text: '#27500a',
   },
   ENTREGUE: {
      bg: 'rgba(15,110,86,0.08)',
      border: 'rgba(15,110,86,0.20)',
      text: '#085041',
   },
   DEVOLVIDO_SEM_REPARO: {
      bg: 'rgba(0,0,0,0.06)',
      border: 'rgba(0,0,0,0.15)',
      text: '#5f5e5a',
   },
};

const SERVICE_ORDER_STATUS_LABELS = {
   AGUARDANDO_RECEBIMENTO: 'Aguardando recebimento',
   EM_TRIAGEM: 'Em triagem',
   AGUARDANDO_PECAS: 'Aguardando peças',
   EM_REPARO: 'Em reparo',
   AGUARDANDO_APROVACAO: 'Aguardando aprovação',
   REPARO_CONCLUIDO: 'Reparo concluído',
   PRONTO_PARA_ENTREGA: 'Pronto para entrega',
   ENTREGUE: 'Entregue',
   DEVOLVIDO_SEM_REPARO: 'Devolvido sem reparo',
};

// Mapa de qual status avança para qual, e o label do botão de ação
const SERVICE_ORDER_NEXT_STATUS_MAP = {
   AGUARDANDO_RECEBIMENTO: {
      next: 'EM_TRIAGEM',
      buttonLabel: 'Iniciar triagem',
   },
   EM_TRIAGEM: { next: 'EM_REPARO', buttonLabel: 'Encaminhar para reparo' },
   AGUARDANDO_PECAS: {
      next: 'EM_REPARO',
      buttonLabel: 'Peças recebidas — iniciar reparo',
   },
   EM_REPARO: {
      next: 'REPARO_CONCLUIDO',
      buttonLabel: 'Marcar reparo como concluído',
   },
   AGUARDANDO_APROVACAO: {
      next: 'EM_REPARO',
      buttonLabel: 'Aprovação recebida — retomar reparo',
   },
   REPARO_CONCLUIDO: {
      next: 'PRONTO_PARA_ENTREGA',
      buttonLabel: 'Liberar para entrega',
   },
   PRONTO_PARA_ENTREGA: {
      next: 'ENTREGUE',
      buttonLabel: 'Confirmar entrega ao cliente',
   },
   ENTREGUE: { next: null, buttonLabel: null },
   DEVOLVIDO_SEM_REPARO: { next: null, buttonLabel: null },
};

// ─────────────────────────────────────────────────────────────────────────────
// Dados mock — substituir por axios.get(`/at/service-orders/${id}`) quando backend pronto
// ─────────────────────────────────────────────────────────────────────────────

const MOCK_SERVICE_ORDER = {
   id: 47,
   os_number: 'OS-2026-0047',
   service_order_status: 'EM_REPARO',
   at_origin: 'NATIVE',
   external_system_id: null,

   // Identificação do equipamento
   equipment_type_label: 'PURIFICADOR DE AGUA',
   equipment_object_label: 'PURIFICADOR DE AGUA',
   equipment_brand: 'IBBL',
   equipment_model: 'DUE',
   equipment_color: 'PRETO',
   pcr_serial_number: '409P2518B92',
   equipment_observations:
      'SEM PINGADEIRA, SEM MANGUEIRA, SEM REFIL, SEM TAMPA DO REFIL COM MARCAS DE USO',

   // Defeito relatado
   reported_defect:
      'CLIENTE RELATOU QUE A AGUA NÃO GELAVA APENAS ESFRIAVA E DESLIGOU O APARELHO POR UM DIA, APÓS LIGAR NOVAMENTE NOTOU QUE NÃO GELAVA MAIS E O COMPRESSOR NÃO FUNCIONAVA',
   obs_general: 'APARELHO DEU ENTRADA DIA 26/03 DANIEL VICTOR QUEM TROUXE',

   // Diagnóstico
   service_type_label: null,
   service_local_label: null,
   technician_diagnosis_notes: '',

   // Pessoas
   requester_name: 'DANIEL VICTOR',
   client_name: '9437946 - DANIEL VICTOR LUIZ',
   vendor_name: '9436278 - AMANDA VITÓRIA DA SILVA ALVES',
   technician_name: null,
   responsible_company_label: 'MYSHOP',
   responsible_branch_label: 'LOJA MATRIZ AV. C',
   sales_origin_label: 'ASSISTÊNCIA TÉCNICA',

   // Financeiro
   freight_value: 0,
   os_total_value: 0.0,
   payment_method: null,
   financial_obs: '',

   // SLA
   sla_due_date: '2026-03-31',
   sla_is_paused: false,
   is_sla_overdue: false,
   sla_days_remaining: 5,

   // Datas
   opened_at: '2026-03-26',
   updated_at: '2026-03-26T09:14:00',

   // Peças/serviços
   parts_used: [
      {
         id: 1,
         product_code: '3003141',
         product_description: 'ENTRADA DE ASSISTÊNCIA',
         quantity: 1,
         unit_value: 0.0,
         total_value: 0.0,
         client_took_it: false,
      },
   ],

   // Histórico de status
   status_logs: [
      {
         id: 1,
         service_order_status: 'AGUARDANDO_RECEBIMENTO',
         changed_by_user_name: 'Amanda Alves',
         changed_at: '2026-03-26T08:00:00',
      },
      {
         id: 2,
         service_order_status: 'EM_TRIAGEM',
         changed_by_user_name: 'Caio Reges',
         changed_at: '2026-03-26T08:45:00',
      },
      {
         id: 3,
         service_order_status: 'EM_REPARO',
         changed_by_user_name: 'Caio Reges',
         changed_at: '2026-03-26T09:14:00',
      },
   ],

   // Fotos (lista de objetos com url presigned do S3)
   attachments: [],
};

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────

function formatDateTimeToBrazilian(isoString) {
   if (!isoString) return '—';
   const date = new Date(isoString);
   return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
   });
}

function formatDateToBrazilian(isoString) {
   if (!isoString) return '—';
   const [year, month, day] = isoString.substring(0, 10).split('-');
   return `${day}/${month}/${year}`;
}

function formatCurrency(value) {
   return Number(value ?? 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
   });
}

// ─────────────────────────────────────────────────────────────────────────────
// Sub-componente: seção colapsável
// ─────────────────────────────────────────────────────────────────────────────

function CollapsibleSection({ title, defaultOpen = true, children }) {
   const [isOpen, setIsOpen] = useState(defaultOpen);

   return (
      <Section>
         <CollapsibleSectionHeader onClick={() => setIsOpen((prev) => !prev)}>
            <SectionTitle style={{ margin: 0 }}>{title}</SectionTitle>
            <CollapsibleToggleIcon $open={isOpen}>▼</CollapsibleToggleIcon>
         </CollapsibleSectionHeader>
         {isOpen && <SectionBody>{children}</SectionBody>}
      </Section>
   );
}

// ─────────────────────────────────────────────────────────────────────────────
// Sub-componente: timeline horizontal com cards
//
// Caminho principal (linha superior):
//   Entrada → Fila p/ diagnóstico → Diagnóstico → Consertado → P/ entrega → Devolvido
//
// Desvios (linha inferior, sempre visíveis):
//   Aguardando peças · Aguardando aprovação · Devolvido s/ reparo
//   Cinzas quando não percorridos; coloridos quando ativos ou atuais.
// ─────────────────────────────────────────────────────────────────────────────

const TIMELINE_MAIN_STEPS = [
   { key: 'AGUARDANDO_RECEBIMENTO', label: 'Entrada na\nassistência' },
   { key: 'EM_TRIAGEM', label: 'Fila para\ndiagnóstico' },
   { key: 'EM_REPARO', label: 'Diagnóstico\nrealizado' },
   { key: 'REPARO_CONCLUIDO', label: 'Aparelho\nconsertado' },
   { key: 'PRONTO_PARA_ENTREGA', label: 'Pronto para\nentrega' },
   { key: 'ENTREGUE', label: 'Aparelho\ndevolvido' },
];

const TIMELINE_DETOUR_STEPS = [
   { key: 'AGUARDANDO_PECAS', label: 'Aguardando\npeças' },
   { key: 'AGUARDANDO_APROVACAO', label: 'Aguardando\naprovação' },
   { key: 'DEVOLVIDO_SEM_REPARO', label: 'Devolvido\ns/ reparo' },
];

function ServiceOrderTimeline({ currentStatus, statusLogs }) {
   const getLogForStatus = (statusKey) =>
      statusLogs?.find((log) => log.service_order_status === statusKey) ?? null;

   const currentMainStepIndex = TIMELINE_MAIN_STEPS.findIndex(
      (step) => step.key === currentStatus
   );

   // Se o status atual é um desvio, qual é o índice do último step principal concluído
   // antes de entrar no desvio
   const lastCompletedMainIndex = (() => {
      if (currentMainStepIndex >= 0) return currentMainStepIndex;
      // status atual é desvio — encontra o último log de step principal
      for (let i = TIMELINE_MAIN_STEPS.length - 1; i >= 0; i -= 1) {
         if (getLogForStatus(TIMELINE_MAIN_STEPS[i].key)) return i;
      }
      return -1;
   })();

   function renderMainStep(step, stepIndex) {
      const stepLog = getLogForStatus(step.key);
      const isCurrentStep = step.key === currentStatus;
      // Concluído: índice abaixo do atual, ou tem log registrado mesmo sendo desvio ativo
      const isDoneStep =
         stepIndex < lastCompletedMainIndex ||
         (stepIndex === lastCompletedMainIndex && !isCurrentStep) ||
         (currentMainStepIndex === -1 && stepLog !== null);
      const isFutureStep = !isCurrentStep && !isDoneStep;
      const isLastStep = stepIndex === TIMELINE_MAIN_STEPS.length - 1;

      const timestampText = stepLog
         ? formatDateTimeToBrazilian(stepLog.changed_at)
         : isFutureStep
           ? 'Pendente'
           : null;

      return (
         <React.Fragment key={step.key}>
            <TimelineStepCard $future={isFutureStep}>
               <TimelineStepDot $current={isCurrentStep} $done={isDoneStep} />
               <TimelineStepLabel $current={isCurrentStep} $done={isDoneStep}>
                  {step.label.split('\n').map((line, i) => (
                     // eslint-disable-next-line react/no-array-index-key
                     <span key={i} style={{ display: 'block' }}>
                        {line}
                     </span>
                  ))}
               </TimelineStepLabel>
               <TimelineStepTimestamp
                  $done={isDoneStep || isCurrentStep}
                  $pending={isFutureStep}
               >
                  {timestampText
                     ? timestampText.split('\n').map((line, i) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <span key={i} style={{ display: 'block' }}>
                             {line}
                          </span>
                       ))
                     : null}
               </TimelineStepTimestamp>
            </TimelineStepCard>
            {!isLastStep && (
               <TimelineHorizontalConnector
                  $done={isDoneStep && !isFutureStep}
               />
            )}
         </React.Fragment>
      );
   }

   return (
      <div>
         {/* ── Trilha principal ── */}
         <TimelineHorizontalWrapper>
            <TimelineHorizontalTrack>
               {TIMELINE_MAIN_STEPS.map((step, stepIndex) =>
                  renderMainStep(step, stepIndex)
               )}
            </TimelineHorizontalTrack>
         </TimelineHorizontalWrapper>

         {/* ── Desvios — sempre visíveis ── */}
         <TimelineDetourRow>
            <TimelineDetourRowLabel>Desvios:</TimelineDetourRowLabel>
            {TIMELINE_DETOUR_STEPS.map((detour) => {
               const detourLog = getLogForStatus(detour.key);
               const isActive = detourLog !== null;
               const isCurrent = detour.key === currentStatus;

               const timestampText =
                  isCurrent || isActive
                     ? formatDateTimeToBrazilian(detourLog?.changed_at)
                     : 'N/A';

               return (
                  <TimelineDetourGroup key={detour.key}>
                     <TimelineDetourConnectorVertical
                        $active={isActive || isCurrent}
                     />
                     <TimelineDetourCard $active={isActive || isCurrent}>
                        <TimelineDetourDot
                           $active={isActive}
                           $current={isCurrent}
                        />
                        <TimelineDetourLabel
                           $active={isActive || isCurrent}
                           $current={isCurrent}
                        >
                           {detour.label.split('\n').map((line, i) => (
                              // eslint-disable-next-line react/no-array-index-key
                              <span key={i} style={{ display: 'block' }}>
                                 {line}
                              </span>
                           ))}
                        </TimelineDetourLabel>
                        <TimelineDetourTimestamp
                           $active={isActive || isCurrent}
                        >
                           {timestampText}
                        </TimelineDetourTimestamp>
                     </TimelineDetourCard>
                  </TimelineDetourGroup>
               );
            })}
         </TimelineDetourRow>
      </div>
   );
}

// ─────────────────────────────────────────────────────────────────────────────
// Componente principal
// ─────────────────────────────────────────────────────────────────────────────

export default function ServiceOrderShow() {
   // eslint-disable-next-line no-unused-vars
   const { serviceOrderId } = useParams();
   const navigate = useNavigate();

   const [isLoading, setIsLoading] = useState(false);

   // TODO: substituir por useState + useEffect com axios.get quando backend pronto
   const [serviceOrder, setServiceOrder] = useState(MOCK_SERVICE_ORDER);

   // Estado do formulário de diagnóstico (campos editáveis)
   const [diagnosisServiceTypeId, setDiagnosisServiceTypeId] = useState('');
   const [diagnosisServiceLocalId, setDiagnosisServiceLocalId] = useState('');
   const [diagnosisTechnicianId, setDiagnosisTechnicianId] = useState('');
   const [diagnosisNotes, setDiagnosisNotes] = useState(
      serviceOrder.technician_diagnosis_notes ?? ''
   );

   // Estado do formulário de peça nova
   const [newPartProductCode, setNewPartProductCode] = useState('');
   const [newPartDescription, setNewPartDescription] = useState('');
   const [newPartQuantity, setNewPartQuantity] = useState(1);
   const [newPartUnitValue, setNewPartUnitValue] = useState('');

   const partsTotal = serviceOrder.parts_used.reduce(
      (accumulator, part) => accumulator + (part.total_value ?? 0),
      0
   );

   const nextStatusConfig =
      SERVICE_ORDER_NEXT_STATUS_MAP[serviceOrder.service_order_status];

   const handleAdvanceStatus = async () => {
      if (!nextStatusConfig?.next) return;

      const confirmMessage = `Deseja avançar a OS para "${SERVICE_ORDER_STATUS_LABELS[nextStatusConfig.next]}"?`;
      if (!window.confirm(confirmMessage)) return;

      setIsLoading(true);
      try {
         // TODO: await axios.patch(`/at/service-orders/${serviceOrder.id}/status`, { new_status: nextStatusConfig.next });
         toast.success(
            `Status atualizado para: ${SERVICE_ORDER_STATUS_LABELS[nextStatusConfig.next]}`
         );

         // Atualiza o mock localmente para refletir o avanço visual
         setServiceOrder((prev) => ({
            ...prev,
            service_order_status: nextStatusConfig.next,
            status_logs: [
               ...prev.status_logs,
               {
                  id: prev.status_logs.length + 1,
                  service_order_status: nextStatusConfig.next,
                  changed_by_user_name: 'Você',
                  changed_at: new Date().toISOString(),
               },
            ],
         }));
      } catch (error) {
         const errorMessage =
            error?.response?.data?.errors?.[0] ??
            error?.message ??
            'Erro ao atualizar status.';
         toast.error(errorMessage);
      } finally {
         setIsLoading(false);
      }
   };

   const handleSaveDiagnosis = async () => {
      if (!diagnosisNotes.trim()) {
         toast.warn('Informe o diagnóstico técnico antes de salvar.');
         return;
      }
      setIsLoading(true);
      try {
         // TODO: await axios.patch(`/at/service-orders/${serviceOrder.id}`, { technician_diagnosis_notes: diagnosisNotes, ... });
         toast.success('Diagnóstico salvo com sucesso.');
         setServiceOrder((prev) => ({
            ...prev,
            technician_diagnosis_notes: diagnosisNotes,
         }));
      } catch (error) {
         toast.error(
            error?.response?.data?.errors?.[0] ?? 'Erro ao salvar diagnóstico.'
         );
      } finally {
         setIsLoading(false);
      }
   };

   const handleAddPart = () => {
      if (!newPartDescription.trim()) {
         toast.warn('Informe a descrição do produto/serviço.');
         return;
      }
      const quantity = parseFloat(newPartQuantity) || 1;
      const unitValue = parseFloat(newPartUnitValue) || 0;
      const newPart = {
         id: Date.now(),
         product_code: newPartProductCode,
         product_description: newPartDescription,
         quantity,
         unit_value: unitValue,
         total_value: quantity * unitValue,
         client_took_it: false,
      };
      setServiceOrder((prev) => ({
         ...prev,
         parts_used: [...prev.parts_used, newPart],
      }));
      setNewPartProductCode('');
      setNewPartDescription('');
      setNewPartQuantity(1);
      setNewPartUnitValue('');
   };

   const handleRemovePart = (partId) => {
      setServiceOrder((prev) => ({
         ...prev,
         parts_used: prev.parts_used.filter((part) => part.id !== partId),
      }));
   };

   const statusColors =
      SERVICE_ORDER_STATUS_COLORS[serviceOrder.service_order_status];

   return (
      <Container $size="lg">
         <Loading isLoading={isLoading} />

         {/* ── Cabeçalho da OS ── */}
         <PageHeader>
            <PageHeaderText>
               <PageTitle>{serviceOrder.os_number}</PageTitle>
               <OsHeaderMeta>
                  <ServiceOrderStatusBadge $statusColor={statusColors}>
                     {
                        SERVICE_ORDER_STATUS_LABELS[
                           serviceOrder.service_order_status
                        ]
                     }
                  </ServiceOrderStatusBadge>
                  <OsMetaSeparator>·</OsMetaSeparator>
                  <OsMetaChip>
                     Abertura: {formatDateToBrazilian(serviceOrder.opened_at)}
                  </OsMetaChip>
                  <OsMetaSeparator>·</OsMetaSeparator>
                  <OsMetaChip>
                     {serviceOrder.pcr_serial_number
                        ? `Série: ${serviceOrder.pcr_serial_number}`
                        : 'Sem série (produto genérico)'}
                  </OsMetaChip>
                  {serviceOrder.at_origin === 'IMPORTED' && (
                     <>
                        <OsMetaSeparator>·</OsMetaSeparator>
                        <OsMetaChip style={{ fontStyle: 'italic' }}>
                           Importado — {serviceOrder.external_system_id}
                        </OsMetaChip>
                     </>
                  )}
               </OsHeaderMeta>
            </PageHeaderText>
            <PageHeaderActions>
               <button
                  type="button"
                  onClick={() =>
                     navigate('/assistencia-tecnica/ordens-de-servico')
                  }
               >
                  ← Voltar
               </button>
               <button type="button" disabled={isLoading}>
                  Imprimir OS
               </button>
            </PageHeaderActions>
         </PageHeader>

         {/* ── Timeline horizontal de ciclo de vida ── */}
         <Section style={{ marginBottom: '16px' }}>
            <SectionHeader>
               <SectionTitle>Ciclo de vida da OS</SectionTitle>
            </SectionHeader>
            <SectionBody>
               <ServiceOrderTimeline
                  currentStatus={serviceOrder.service_order_status}
                  statusLogs={serviceOrder.status_logs}
               />
            </SectionBody>
         </Section>

         {/* ── Layout: main + sidebar ── */}
         <OsLayout>
            {/* ── Coluna principal ── */}
            <OsMainContent>
               {/* 1. Identificação do equipamento */}
               <CollapsibleSection title="Equipamento">
                  <FormGrid $cols={12}>
                     <Field className="col-4">
                        <label>Tipo do objeto</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.equipment_type_label}
                        />
                     </Field>
                     <Field className="col-8">
                        <label>Objeto</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.equipment_object_label}
                        />
                     </Field>
                     <Field className="col-3">
                        <label>Marca</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.equipment_brand}
                        />
                     </Field>
                     <Field className="col-3">
                        <label>Modelo</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.equipment_model}
                        />
                     </Field>
                     <Field className="col-3">
                        <label>Cor</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.equipment_color}
                        />
                     </Field>
                     <Field className="col-3">
                        <label>N. Serial / CQ</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.pcr_serial_number ?? ''}
                           placeholder="S/ série"
                        />
                     </Field>
                     <Field className="col-12">
                        <label>
                           Obs. do objeto (condições, avarias, acessórios
                           recebidos)
                        </label>
                        <ObjectObsBlock>
                           {serviceOrder.equipment_observations || '—'}
                        </ObjectObsBlock>
                     </Field>
                  </FormGrid>
               </CollapsibleSection>

               {/* 2. Defeito relatado */}
               <CollapsibleSection title="Defeito relatado pelo cliente">
                  <DefectReportBlock>
                     {serviceOrder.reported_defect || (
                        <span style={{ color: '#ccc', fontStyle: 'italic' }}>
                           Nenhum defeito descrito.
                        </span>
                     )}
                  </DefectReportBlock>
                  {serviceOrder.obs_general && (
                     <div style={{ marginTop: '12px' }}>
                        <label
                           style={{
                              fontSize: '11px',
                              fontWeight: '700',
                              color: '#888',
                              textTransform: 'uppercase',
                              letterSpacing: '0.04em',
                           }}
                        >
                           Obs. geral
                        </label>
                        <p
                           style={{
                              fontSize: '13px',
                              margin: '4px 0 0',
                              color: '#555',
                              lineHeight: '1.5',
                           }}
                        >
                           {serviceOrder.obs_general}
                        </p>
                     </div>
                  )}
               </CollapsibleSection>

               {/* 3. Diagnóstico e execução */}
               <CollapsibleSection title="Diagnóstico e execução">
                  <FormGrid $cols={12}>
                     <Field className="col-4">
                        <label>Tipo de atendimento</label>
                        <select
                           value={diagnosisServiceTypeId}
                           onChange={(e) =>
                              setDiagnosisServiceTypeId(e.target.value)
                           }
                        >
                           <option value="">Selecione...</option>
                           <option value="1">Assistência interna</option>
                           <option value="2">Visita técnica</option>
                           <option value="3">Garantia de fábrica</option>
                        </select>
                     </Field>
                     <Field className="col-4">
                        <label>Local do serviço</label>
                        <select
                           value={diagnosisServiceLocalId}
                           onChange={(e) =>
                              setDiagnosisServiceLocalId(e.target.value)
                           }
                        >
                           <option value="">Selecione...</option>
                           <option value="1">Loja Matriz</option>
                           <option value="2">Endereço do cliente</option>
                        </select>
                     </Field>
                     <Field className="col-4">
                        <label>Técnico responsável</label>
                        <select
                           value={diagnosisTechnicianId}
                           onChange={(e) =>
                              setDiagnosisTechnicianId(e.target.value)
                           }
                        >
                           <option value="">Selecione o técnico...</option>
                           <option value="1">Lucas Teixeira</option>
                           <option value="2">Ana Rodrigues</option>
                           <option value="3">Marcos Vieira</option>
                        </select>
                     </Field>
                     <Field className="col-12">
                        <label>Diagnóstico técnico</label>
                        <textarea
                           rows={4}
                           value={diagnosisNotes}
                           onChange={(e) => setDiagnosisNotes(e.target.value)}
                           placeholder="Descreva o diagnóstico, peças trocadas, procedimento realizado..."
                           style={{
                              resize: 'vertical',
                              fontFamily: 'inherit',
                              fontSize: '13px',
                              lineHeight: '1.6',
                           }}
                        />
                     </Field>
                  </FormGrid>

                  {serviceOrder.technician_diagnosis_notes && (
                     <div style={{ marginTop: '12px' }}>
                        <label
                           style={{
                              fontSize: '11px',
                              fontWeight: '700',
                              color: '#888',
                              textTransform: 'uppercase',
                              letterSpacing: '0.04em',
                              display: 'block',
                              marginBottom: '6px',
                           }}
                        >
                           Último diagnóstico salvo
                        </label>
                        <DiagnosisBlock>
                           {serviceOrder.technician_diagnosis_notes}
                        </DiagnosisBlock>
                     </div>
                  )}

                  <div
                     style={{
                        marginTop: '12px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                     }}
                  >
                     <button
                        type="button"
                        onClick={handleSaveDiagnosis}
                        disabled={isLoading}
                     >
                        Salvar diagnóstico
                     </button>
                  </div>
               </CollapsibleSection>

               {/* 4. Produtos e serviços */}
               <CollapsibleSection title="Produtos e serviços utilizados">
                  {/* Formulário de adição de peça */}
                  <PartsTableActionBar>
                     <Field style={{ flex: '0 0 100px' }}>
                        <label>Cód. produto</label>
                        <input
                           type="text"
                           value={newPartProductCode}
                           onChange={(e) =>
                              setNewPartProductCode(e.target.value)
                           }
                           placeholder="Ex.: 3003141"
                        />
                     </Field>
                     <Field style={{ flex: '1 1 200px' }}>
                        <label>Descrição</label>
                        <input
                           type="text"
                           value={newPartDescription}
                           onChange={(e) =>
                              setNewPartDescription(e.target.value)
                           }
                           placeholder="Nome do produto ou serviço..."
                        />
                     </Field>
                     <Field style={{ flex: '0 0 70px' }}>
                        <label>Qtde</label>
                        <input
                           type="number"
                           min="1"
                           value={newPartQuantity}
                           onChange={(e) => setNewPartQuantity(e.target.value)}
                        />
                     </Field>
                     <Field style={{ flex: '0 0 110px' }}>
                        <label>V. Unitário (R$)</label>
                        <input
                           type="number"
                           min="0"
                           step="0.01"
                           value={newPartUnitValue}
                           onChange={(e) => setNewPartUnitValue(e.target.value)}
                           placeholder="0,00"
                        />
                     </Field>
                     <Field style={{ flex: '0 0 auto', paddingBottom: '0' }}>
                        <label>&nbsp;</label>
                        <button
                           type="button"
                           onClick={handleAddPart}
                           disabled={isLoading}
                        >
                           + Adicionar
                        </button>
                     </Field>
                  </PartsTableActionBar>

                  <TableWrapper $minWidth="560px">
                     <Table>
                        <thead>
                           <tr>
                              <th>Código</th>
                              <th>Descrição</th>
                              <th className="center">Qtde</th>
                              <th className="center">V. Unit.</th>
                              <th className="center">V. Total</th>
                              <th className="center">Cliente levou?</th>
                              <th className="center">Ação</th>
                           </tr>
                        </thead>
                        <tbody>
                           {serviceOrder.parts_used.length === 0 && (
                              <tr>
                                 <td
                                    colSpan={7}
                                    style={{
                                       textAlign: 'center',
                                       color: '#aaa',
                                       fontStyle: 'italic',
                                    }}
                                 >
                                    Nenhum produto ou serviço adicionado.
                                 </td>
                              </tr>
                           )}
                           {serviceOrder.parts_used.map((part) => (
                              <tr key={String(part.id)}>
                                 <td>{part.product_code || '—'}</td>
                                 <td>{part.product_description}</td>
                                 <td className="center">{part.quantity}</td>
                                 <td className="center">
                                    {formatCurrency(part.unit_value)}
                                 </td>
                                 <td className="center">
                                    {formatCurrency(part.total_value)}
                                 </td>
                                 <td className="center">
                                    <input
                                       type="checkbox"
                                       defaultChecked={part.client_took_it}
                                       title="Cliente levou o item?"
                                    />
                                 </td>
                                 <td className="center">
                                    <button
                                       type="button"
                                       onClick={() => handleRemovePart(part.id)}
                                       style={{
                                          background: 'none',
                                          border: 'none',
                                          color: '#b71c1c',
                                          cursor: 'pointer',
                                          fontWeight: '700',
                                          fontSize: '13px',
                                       }}
                                       title="Remover item"
                                    >
                                       ✕
                                    </button>
                                 </td>
                              </tr>
                           ))}
                        </tbody>
                     </Table>
                  </TableWrapper>

                  <PartsTotalRow>
                     <span>Frete:</span>
                     <span>{formatCurrency(serviceOrder.freight_value)}</span>
                     <OsMetaSeparator>|</OsMetaSeparator>
                     <span>Total OS:</span>
                     <PartsTotalValue>
                        {formatCurrency(
                           partsTotal + serviceOrder.freight_value
                        )}
                     </PartsTotalValue>
                  </PartsTotalRow>
               </CollapsibleSection>

               {/* 5. Fotos */}
               <CollapsibleSection title="Fotos" defaultOpen={false}>
                  <PhotoGrid>
                     {serviceOrder.attachments.map((attachment) => (
                        <PhotoThumb key={attachment.id}>
                           <img
                              src={attachment.presigned_url}
                              alt="Foto da OS"
                           />
                        </PhotoThumb>
                     ))}
                     <PhotoUploadButton title="Adicionar foto">
                        <span style={{ fontSize: '22px' }}>📷</span>
                        <span>Adicionar</span>
                        <input type="file" accept="image/*" multiple />
                     </PhotoUploadButton>
                  </PhotoGrid>
                  {serviceOrder.attachments.length === 0 && (
                     <p
                        style={{
                           fontSize: '12px',
                           color: '#bbb',
                           fontStyle: 'italic',
                           margin: '8px 0 0',
                        }}
                     >
                        Nenhuma foto anexada ainda.
                     </p>
                  )}
               </CollapsibleSection>

               {/* 6. Pessoas */}
               <CollapsibleSection title="Envolvidos" defaultOpen={false}>
                  <FormGrid $cols={12}>
                     <Field className="col-6">
                        <label>Solicitante</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.requester_name}
                        />
                     </Field>
                     <Field className="col-6">
                        <label>Cliente</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.client_name}
                           readOnly
                        />
                     </Field>
                     <Field className="col-6">
                        <label>Vendedor responsável</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.vendor_name}
                           readOnly
                        />
                     </Field>
                     <Field className="col-3">
                        <label>Empresa</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.responsible_company_label}
                           readOnly
                        />
                     </Field>
                     <Field className="col-3">
                        <label>CD / Loja</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.responsible_branch_label}
                           readOnly
                        />
                     </Field>
                     <Field className="col-4">
                        <label>Origem da venda</label>
                        <input
                           type="text"
                           defaultValue={serviceOrder.sales_origin_label}
                           readOnly
                        />
                     </Field>
                  </FormGrid>
               </CollapsibleSection>

               {/* 7. Financeiro */}
               <CollapsibleSection
                  title="Anotação financeira"
                  defaultOpen={false}
               >
                  <FormGrid $cols={12}>
                     <Field className="col-12">
                        <label>Forma de pagamento</label>
                        <select
                           defaultValue={serviceOrder.payment_method ?? ''}
                        >
                           <option value="">Não informado</option>
                           <option value="dinheiro">Dinheiro</option>
                           <option value="cartao_debito">
                              Cartão de Débito
                           </option>
                           <option value="cartao_credito">
                              Cartão de Crédito
                           </option>
                           <option value="cheque">Cheque</option>
                           <option value="boleto">Boleto</option>
                           <option value="transferencia">Transferência</option>
                           <option value="pix">Pix</option>
                        </select>
                     </Field>
                     <Field className="col-12">
                        <label>Observação financeira</label>
                        <textarea
                           rows={3}
                           defaultValue={serviceOrder.financial_obs}
                           placeholder="Informações sobre pagamento, parcelamento, etc."
                           style={{
                              resize: 'vertical',
                              fontFamily: 'inherit',
                              fontSize: '13px',
                           }}
                        />
                     </Field>
                  </FormGrid>
               </CollapsibleSection>
            </OsMainContent>

            {/* ── Sidebar ── */}
            <OsSidebar>
               {/* SLA */}
               <Section>
                  <SectionHeader>
                     <SectionTitle>SLA</SectionTitle>
                  </SectionHeader>
                  <SectionBody>
                     <SlaCountdownBadge $overdue={serviceOrder.is_sla_overdue}>
                        <span>Prazo:</span>
                        <span>
                           {formatDateToBrazilian(serviceOrder.sla_due_date)}
                        </span>
                     </SlaCountdownBadge>
                     <p
                        style={{
                           fontSize: '11px',
                           color: '#aaa',
                           margin: '8px 0 0',
                           lineHeight: '1.5',
                        }}
                     >
                        {serviceOrder.sla_is_paused
                           ? '⏸ SLA pausado (aguardando fator externo)'
                           : serviceOrder.is_sla_overdue
                             ? '⚠ OS em atraso'
                             : `${serviceOrder.sla_days_remaining} dia(s) restante(s)`}
                     </p>
                  </SectionBody>
               </Section>

               {/* Avançar status */}
               {nextStatusConfig?.buttonLabel && (
                  <Section>
                     <SectionHeader>
                        <SectionTitle>Próximo passo</SectionTitle>
                     </SectionHeader>
                     <SectionBody>
                        <p
                           style={{
                              fontSize: '12px',
                              color: '#888',
                              margin: '0 0 10px',
                              lineHeight: '1.5',
                           }}
                        >
                           O próximo status será:{' '}
                           <strong>
                              {
                                 SERVICE_ORDER_STATUS_LABELS[
                                    nextStatusConfig.next
                                 ]
                              }
                           </strong>
                        </p>
                        <StatusAdvanceButton
                           type="button"
                           onClick={handleAdvanceStatus}
                           disabled={isLoading}
                        >
                           {nextStatusConfig.buttonLabel}
                        </StatusAdvanceButton>
                        <div
                           style={{
                              marginTop: '10px',
                              display: 'flex',
                              gap: '8px',
                              flexDirection: 'column',
                           }}
                        >
                           <button
                              type="button"
                              style={{ width: '100%', fontSize: '12px' }}
                              onClick={() => {
                                 if (
                                    window.confirm(
                                       'Marcar como "Aguardando peças"?'
                                    )
                                 ) {
                                    toast.info(
                                       'Status atualizado para: Aguardando peças.'
                                    );
                                 }
                              }}
                           >
                              ⏸ Aguardar peças
                           </button>
                           <button
                              type="button"
                              style={{ width: '100%', fontSize: '12px' }}
                              onClick={() => {
                                 if (
                                    window.confirm(
                                       'Enviar orçamento para aprovação do cliente?'
                                    )
                                 ) {
                                    toast.info(
                                       'Status atualizado para: Aguardando aprovação.'
                                    );
                                 }
                              }}
                           >
                              💬 Aguardar aprovação
                           </button>
                        </div>
                     </SectionBody>
                  </Section>
               )}
            </OsSidebar>
         </OsLayout>
      </Container>
   );
}
